<template>
  <div v-if="boxType === 'storage_main'" class="box-size-guide-tip-wrap storage-main" :class="{ sm: size === 'small' }">
    <div class="box-section">
      <div class="pc-row">
        <div class="checkbox-row"><img src="~/assets/img/icons/icn_black_check.svg" class="icn-black-check"></div>
        <p>밥아저씨 박스 한 박스에는<br>대봉 하나와 거의 비슷하거나<br>조금 적은 양이 들어갑니다.</p>
        <div class="highlight">박스에 들어가지 않는 물건은<br>안타깝게도 보관할 수 없어요.</div>
      </div>
      <img src="~assets/img/box/box_yellow_size_2.svg" class="yellow-box-2" alt="보관 박스 사이즈">
    </div>
    <div class="box-section">
      <img src="~/assets/img/box/img_box_standard_detail.svg" class="img-box-detail">
    </div>
  </div>
  <div v-else class="box-size-guide-tip-wrap" :class="{ sm: size === 'small' }">
    <slot name="title"></slot>
    <label class="black-badge">사이즈 tip</label>
    <p v-if="boxType === 'storage'">기내용 캐리어 3개에 들어가는 짐 양<br>2리터 생수병 24개 + 자투리 공간</p>
    <p v-else>기내용 캐리어 2개에 들어가는 짐 양<br>2리터 생수병 15개 + 자투리 공간 정도</p>
    <img v-if="boxType === 'storage'" class="black-box" src="~assets/img/box/box_black_size.svg" alt="보관 박스 사이즈">
    <img v-else src="~assets/img/box/box_yellow_size.svg" class="yellow-box" alt="운송 박스 사이즈">
    <div class="img-guide">내경 사이즈를 실측하였습니다.</div>
  </div>
</template>

<script>
export default {
  name: "BoxStandard",
  props: ['boxType', 'size']
}
</script>

<style scoped lang="scss">
.box-size-guide-tip-wrap {
  padding: 35px 55px 35px 40px;
  background-color: #f2f5fa;
  font-size: 16px;
  line-height: 1.75;
  text-align: center;
  width: 450px;
  @include border-round(10px);

  .black-badge {
    line-height: 27px;
    font-size: 15px;
    font-weight: bold;
    padding: 0 15px;
    float: left;
    background-color: #000;
    color: #fff;
    @include border-round(14px);
  }

  .img-guide {
    color: #aaaeb6;
    font-size: 14px;
    padding-top: 25px;
  }

  img {
    margin: 35px auto 0 70px;
    vertical-align: top;
    width: 200px;
    height: auto;
  }

  p {
    padding-left: 109px;
    margin: 0;
    white-space: nowrap;
    text-align: left;
  }

  &.sm {
    padding: 20px 15px;
    font-size: 14px;
    width: auto;

    .black-badge {
      line-height: 25px;
      font-size: 14px;
      padding: 0 13px;
      margin: 0;
    }

    p {
      clear: left;
      padding: 5px 0 0 5px;
    }

    img {
      width: 140px;
      margin: 0;
    }

    .img-guide {
      font-size: 13px;
      padding-top: 15px;
    }
  }

  &.storage-main {
    display: flex;
    text-align: left;
    padding: 15px 20px;

    .icn-black-check {
      width: 10px;
      height: 10px;
      padding: 0;
      margin: 0;
    }

    p {
      font-size: 10px !important;
      line-height: 1.2 !important;
      color: #000;
      padding: 0 0 14px;
      vertical-align: top;
      font-weight: normal;
      margin-top: -8px;
    }

    img.yellow-box-2 {
      width: 126.3px;
    }

    img.img-box-detail {
      width: 200px;
      height: auto;
      margin-left: 22px;
    }

    .highlight {
      color: #004a9a;
      font-size: 10px;
      line-height: 1.2;
      font-weight: 800;
      padding-bottom: 8px;
    }
  }

  @include respond(tablet) {
    padding: 17px 20px;
    width: 100%;

    p {
      font-size: 8px;
      line-height: 13px;
      padding-left: 65px;
    }

    .black-badge {
      line-height: 18px;
      font-size: 8px;
      padding: 0 10px;
    }

    .img-guide {
      line-height: 23px;
      font-size: 8px;
      padding-top: 7px;
    }

    img {
      width: 130px;
      margin-top: 25px;
      margin-left: 35px;
    }

    &.storage-main {
      flex-direction: column;
      padding: 15px 10px 15px 20px;

      .box-section:nth-of-type(1) {
        display: flex;
        padding-bottom: 15px;
      }

      .pc-row {
        padding-right: 10px;
        white-space: nowrap;
      }

      .img-box-detail {
        margin-left: 10px;
      }
    }

    @include respond(xs-mobile) {
      img {
        margin: 25px auto 0 30px;
      }

      &.storage-main {
        padding: 15px 20px;

        .box-section:nth-of-type(1) {
          display: block;
          //padding-bottom: 15px;
        }

        .img-box-detail {
          margin-left: 0px !important;
        }
      }
    }
  }
}
</style>
